import { Alert, Button, Link, Stack, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { iorganizationManagementApiV1 as iorganizationManagementApi } from '@deepup/internal-apis';
import { useParams } from 'react-router-dom';
import { UserRole } from '@userProfile/redux/types';
import { userProfileSelectors } from '@userProfile/redux';
import { useSelector } from 'react-redux';
import { useProjectMetadata } from './ProjectMetadata/MetadataInfoBox';

const isPlandataAvailable = (networkDesignState: iorganizationManagementApi.NetworkDesignState) => {
  return networkDesignState === iorganizationManagementApi.NetworkDesignState.AVAILABLE;
};

const networkDesignStateToText = (
  networkDesignState: iorganizationManagementApi.NetworkDesignState,
) => {
  switch (networkDesignState) {
    case iorganizationManagementApi.NetworkDesignState.AVAILABLE:
      return 'Available';
    case iorganizationManagementApi.NetworkDesignState.INCOMPLETE:
      return 'Incomplete';
    case iorganizationManagementApi.NetworkDesignState.PENDING:
      return 'Pending';
    case iorganizationManagementApi.NetworkDesignState.IN_REVIEW:
      return 'In review';
  }
  return 'Unknown';
};

export const PlandataAlert = () => {
  const { projectId } = useParams();
  const { metadata } = useProjectMetadata({ projectId });
  const role = useSelector(userProfileSelectors.selectUserRole);
  const isAdmin = role === UserRole.Admin;
  if (!metadata) {
    return null;
  }

  if (isPlandataAvailable(metadata.networkDesignState)) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ alignItems: 'center' }}>
      <Stack direction="row" gap={1} alignItems="center">
        <Typography variant="body1">
          Design data is unavailable. Current state:{' '}
          {networkDesignStateToText(metadata.networkDesignState)}.
        </Typography>
        {isAdmin ? (
          <Button
            component={Link}
            startIcon={<OpenInNew />}
            href={`/iadmin/projects/${projectId}`}
            target="_blank"
          >
            Change state in Admin
          </Button>
        ) : (
          <Typography variant="body1">
            Please contact your administrator to get the design data.
          </Typography>
        )}
      </Stack>
    </Alert>
  );
};
